import { IconName } from '@optimus-web/core';
import { Container, ToggleArrow } from './style';

export interface InfoBoxProps {
    children: React.ReactNode;
    opened: boolean;
    toggleOpened: () => void;
}

export const InfoBox = ({ children, opened, toggleOpened, ...other }: InfoBoxProps) => (
    <Container opened={opened} {...other}>
        <ToggleArrow
            onClick={toggleOpened}
            variant="primary"
            icon={opened ? IconName.ChevronRight : IconName.ChevronLeft}
            data-test-toggle
            type="button"
            {...other}
        />
        {children}
    </Container>
);
